module.exports = __webpack_public_path__ + "img/tyjr-icon.6a6c7917.png";